import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";
import { withRouter } from "react-router-dom";

class SuccessPopup extends Component {

    handleOk = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.props.history.push("/resetquestion");
    };

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    render() {
      return (
    <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999
        }}
    >

        <div
            style={{
                width: "500px",
                background: "#fff",
                borderRadius: "10px",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "20px 25px 30px 25px",
                minHeight: "220px"
            }}
        >

            <div
                style={{
                    textAlign: "right"
                }}
            >
                <button
                    type="button"
                    onClick={this.handleClose}
                    style={{
                        border: "none",
                        background: "transparent",
                        fontSize: "30px",
                        cursor: "pointer",
                        color: "#777"
                    }}
                >
                    &times;
                </button>
            </div>

            <div
                style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "18px",
                    lineHeight: "35px",
                    color: "#333",
                    padding: "0 20px",
                    fontWeight: "bold"
                }}
            >
                {this.props.message}
            </div>

            <div
                style={{
                    textAlign: "center",
                    marginTop: "40px"
                }}
            >
                <RaisedButton
                    label="OK"
                    backgroundColor="#333"
                    labelColor="#fff"
                    onClick={this.handleOk}
                />
            </div>

        </div>

    </div>
);
    }
}

export default withRouter(SuccessPopup);


// WEBPACK FOOTER //
// ./src/components/secretqbutton/secretqbutton.jsx